<template>
  <div>
    <v-navigation-drawer
      v-model="drawer"
      enable-resize-watcher
      fixed
      app
      class="grey darken-4"
    >
      <side-drawer></side-drawer>
    </v-navigation-drawer>
    <v-toolbar
      app
      color="primary"
    >
      <v-btn icon @click="goBack()">
        <v-icon>keyboard_arrow_left</v-icon>
      </v-btn>
      <v-spacer></v-spacer>
      <v-toolbar-title>Shipments for Order No. {{ salesOrderNo }}</v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-content>
      <v-list three-line fill-height v-if="items.length > 0">
        <template
          v-for="(item, index) in items"
        >
          <v-list-tile
            :key="item.deliveryOrderNo"
            avatar
            ripple
          >
            <v-list-tile-action style="max-width: 100px;">
              <v-list-tile-action-text class="text-xs-center">
                <!--<v-icon medium color="green">check_circle_outline</v-icon>-->
                <div class="caption" style="word-wrap: break-word;">{{ item.storeName | allCaps }}</div>
              </v-list-tile-action-text>
            </v-list-tile-action>

            <v-list-tile-content>
              <v-list-tile-title>
                <router-link class="font-weight-bold orange--text text--lighten-2" :to="'/shipment/' + item.deliveryOrderNo">
                  {{ (item.customCourierName.length > 0 ? item.customCourierName : item.courierName + ' - ' +  item.serviceName) }}
                </router-link>
              </v-list-tile-title>
              <v-list-tile-sub-title class="text--primary">{{ item.createdDateTime | formatDate('DD MMM YYYY HH:mm', profile.gmtTimezone) }}</v-list-tile-sub-title>
              <v-list-tile-sub-title class="text--primary" v-if="item.trackingNo">
                Tracking No:
                <a :href="item.fullTrackingUrl" target="_blank" class="white--text">
                  {{ item.trackingNo }}
                </a>
              </v-list-tile-sub-title>
            </v-list-tile-content>

            <div class="mr-3" v-if="isAccessCosting && item.courierId !== 'COU-INSTANT' && (item.storeType === 'branch' || item.isShippingForBranch || item.isPricingManagedByMV === '1')">
              <v-container fluid grid-list-lg class="pa-0" style="max-width:450px;">
                <v-layout row wrap>
                  <v-flex xs3>
                    <v-select
                      v-model="item.realShippingCostCurrencyCode"
                      v-bind:items="currencies"
                      item-text="sign"
                      item-value="currencyCode"
                      label="Currency"
                      hide-details
                      @change="item.realShippingCostExchangeRateToBase = getRateToBase(item.realShippingCostCurrencyCode); item.saveButtonStatus = '';"
                    ></v-select>
                  </v-flex>
                  <v-flex xs4>
                    <v-text-field
                      v-model="item.realShippingCost"
                      label="Real Shipping Cost"
                      hide-details
                      @keyup="item.saveButtonStatus = ''"
                    ></v-text-field>
                    <div v-if="item.realShippingCostCurrencyCode !== def.currency.currencyCode && item.realShippingCost > 0 && item.realShippingCostExchangeRateToBase > 0" class="caption font-weight-light grey--text">{{ def.currency.sign }}{{ formatPrice(item.realShippingCost * item.realShippingCostExchangeRateToBase, def.currency.decimals, def.currency.decimalSign) }}</div>
                  </v-flex>
                  <v-flex xs5>
                    <v-text-field
                      v-model="item.realShippingCostExchangeRateToBase"
                      label="Rate to USD"
                      hide-details
                      @keyup="item.saveButtonStatus = ''"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-container>
              <span v-if="item.realShippingCostUpdatedDateTime" class="caption grey--text">
                Updated {{ item.realShippingCostUpdatedDateTime | formatDate('DD MMM YYYY HH:mm', profile.gmtTimezone) }}
                <span v-if="item.realShippingCostUpdatedByAdminName">by {{ item.realShippingCostUpdatedByAdminName }}</span>
              </span>
            </div>

            <v-list-tile-action>
              <v-list-tile-action-text>
                <v-btn
                  v-if="isAccessCosting && item.courierId !== 'COU-INSTANT' && (item.storeType === 'branch' || item.isShippingForBranch || item.isPricingManagedByMV === '1')"
                  @click="saveRealShippingCost(item)"
                  outline
                  :disabled="!(item.realShippingCostCurrencyCode !== '' && item.realShippingCost > 0 && item.realShippingCostExchangeRateToBase > 0) || item.saveButtonStatus === 'disabled'"
                >
                  <v-progress-circular
                    v-if="item.saveButtonStatus === 'saving'"
                    indeterminate
                    small
                    color="primary"
                    :width=3
                    class="ma-3"
                    dark
                  ></v-progress-circular>
                  <span v-else-if="item.saveButtonStatus === 'success'">
                    <v-icon medium color="green">check_circle_outline</v-icon>
                  </span>
                  <span v-else>
                    Save
                  </span>
                </v-btn>
              </v-list-tile-action-text>
            </v-list-tile-action>

          </v-list-tile>
          <v-divider
            v-if="index + 1 < items.length"
            :key="index"
          ></v-divider>
        </template>
        <template
          v-if="items.length <= 0"
        >
          <v-flex
            xs12
            justify-center
            align-center
            text-xs-center
          >
            <v-icon x-large color="primary">error_outline</v-icon>
            <div>
              No shipment yet
            </div>
          </v-flex>
        </template>

      </v-list>
      <!--<v-fab-transition>
        <v-btn
          color=primary
          dark
          fab
          fixed
          bottom
          right
        >
          <v-icon>add</v-icon>
        </v-btn>
      </v-fab-transition>-->
      <v-dialog
        v-model="loading"
        hide-overlay
        persistent
        width="220"
      >
        <loading></loading>
      </v-dialog>
    </v-content>
  </div>
</template>

<style scoped>
  .media {
    height: 100%;
    margin: 0;
  }

  table.v-table tbody td:first-child {
    padding: 15px 15px;
  }

  .item-name {
    padding: 5px !important;
  }

  .item-thumb {
    width: 60px;
    height: auto;
  }
</style>

<script>
import SideDrawer from '@/components/SideDrawer.vue'
import axios from 'axios'
import router from '../router'
import Loading from '@/components/Loading.vue'

export default {
  props: [
    'salesOrderNo'
  ],
  components: {
    SideDrawer,
    Loading
  },
  data () {
    return {
      profile: this.$store.getters.getProfile,
      def: this.$store.getters.getDef,
      drawer: false,
      loading: false,
      items: [],
      currencies: [],
      isAccessCosting: false
    }
  },
  mounted () {
    this.openDrawerForDesktop()
    this.listSalesOrderShipments()
    this.getCurrencies()

    if (typeof this.profile.permissions !== 'undefined') {
      for (var i in this.profile.permissions) {
        if (this.profile.permissions[i].permissionId === 'PEM-COSTING' && this.profile.permissions[i].isRead === '1') {
          this.isAccessCosting = true
          break
        }
      }
    }
  },
  methods: {
    getRateToBase: function (currencyCode) {
      for (var i in this.currencies) {
        if (this.currencies[i].currencyCode === currencyCode) {
          return this.currencies[i].exchangeRateToBase
        }
      }
      return 0
    },
    getCurrencies: function () {
      var _this = this
      _this.loading = true
      axios.get(process.env.VUE_APP_API_ROOT + '/v1/currencies')
        .then(resp => {
          console.log(resp.data)
          _this.loading = false
          if (resp.data.status === 'success') {
            for (var i in resp.data.data) {
              if (resp.data.data[i].currencyCode === _this.currencyCode) {
                resp.data.data[i].exchangeRateToBase = _this.exchangeRateToBase
              }
            }
            _this.currencies = resp.data.data
          } else {
            console.log('unable to load currencies: ' + resp.data.message)
          }
        })
        .catch(function (error) {
          if (error.response) {
            console.log(error.response.status)
            if (error.response.status === 401) {
              router.push('/login?next=' + _this.$route.fullPath)
            } else if (error.response.status === 403) {
              _this.showAlert(error)
            }
            _this.loading = false
          }
        })
    },
    listSalesOrderShipments: function () {
      var _this = this
      _this.loading = true
      axios.get(process.env.VUE_APP_API_ROOT + '/v1/sales/' + _this.salesOrderNo)
        .then(resp => {
          _this.loading = false
          if (resp.data.status === 'success') {
            for (var i in resp.data.data.deliveryOrders) {
              // button statuses: '', disabled, saving
              resp.data.data.deliveryOrders[i].saveButtonStatus = 'disabled'
              resp.data.data.deliveryOrders[i].isShippingForBranch = false
              for (var j in resp.data.data.deliveryOrders[i].items) {
                if (resp.data.data.deliveryOrders[i].items[j].sellerUserId !== resp.data.data.deliveryOrders[i].sellerUserId && (resp.data.data.deliveryOrders[i].items[j].sellerType === 'branch' || resp.data.data.deliveryOrders[i].items[j].isSellerPricingManagedByMV === '1')) {
                  resp.data.data.deliveryOrders[i].isShippingForBranch = true
                  break
                }
              }
            }
            _this.items = resp.data.data.deliveryOrders
          } else {
            console.log('unable to load shipments: ' + resp.data.message)
          }
        })
        .catch(function (error) {
          if (error.response) {
            console.log(error.response.status)
            if (error.response.status === 401) {
              router.push('/login?next=' + _this.$route.fullPath)
            }
            _this.loading = false
          }
        })
    },
    saveRealShippingCost (item) {
      var _this = this
      item.saveButtonStatus = 'saving'
      axios.put(process.env.VUE_APP_API_ROOT + '/v1/costing/delivery/' + item.deliveryOrderNo, {
        currencyCode: item.realShippingCostCurrencyCode,
        exchangeRateToBase: item.realShippingCostExchangeRateToBase,
        realShippingCost: item.realShippingCost
      })
        .then(resp => {
          if (resp.data.status === 'success') {
            item.saveButtonStatus = 'success'
            setTimeout(function () {
              item.saveButtonStatus = 'disabled'
            }, (5 * 1000))
          } else {
            item.saveButtonStatus = ''
            window.alert('Unable to save real shipping cost: ' + resp.data.message)
          }
        })
        .catch(function (error) {
          if (error.response) {
            console.log(error.response.status)
            if (error.response.status === 401) {
              router.push('/login?next=' + _this.$route.fullPath)
            }
            item.saveButtonStatus = ''
          }
        })
    }
  }

}
</script>
